import { Helmet } from "react-helmet-async";

import { useEffect, useState } from "react";
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Button,
  Popover,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TableHead,
  CircularProgress,
  Box,
  Avatar,
  TextField,
  InputAdornment,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";

// components

import Iconify from "../components/iconify";
import Scrollbar from "../components/scrollbar";

import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
// ----------------------------------------------------------------------

export default function GameQuestionsPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(null);
  const [rows, setRows] = useState(null);
  const [defaultRows, setDefaultRows] = useState(null);
  const [match, setMatch] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const [openConfirm, setOpenConfirm] = useState(false);
  const [openId, setOpenId] = useState(null);

  useEffect(() => {
    if (searchParams.has("match_id")) {
      let matchId = searchParams.get("match_id");
      setMatch(matchId);
      axios
        .get(
          `${process.env.REACT_APP_API_BASE_URL}/admin/game/${matchId}/questions`
        )
        .then(function (response) {
          setRows(response.data.questions);
          setDefaultRows(response.data.questions);
        });
    } else {
      navigate("/404");
    }
  }, [setSearchParams, searchParams, navigate]);

  const handleGenerateQuestions = () => {
    setLoading(true);

    axios
      .post(
        `${process.env.REACT_APP_API_BASE_URL}/admin/game/${match}/generate-questions`
      )
      .then(function (response) {
        window.location.reload(false);
      });
  };
  const handleOpenMenu = (event) => {
    setOpen(event.currentTarget);
    setOpenId(event.currentTarget.id);
  };

  const handleCloseMenu = () => {
    setOpen(null);
    setOpenId(null);
  };

  const deleteGameHandler = () => {
    setLoading(true);
    setOpen(false);
    setOpenConfirm(false);
    axios
      .post(
        `${process.env.REACT_APP_API_BASE_URL}/admin/game/${match}/delete-question`,
        { questionId: openId }
      )
      .then(function (response) {
        window.location.reload(false);
      });
  };
  const requestSearch = (searchedVal) => {
    if (searchedVal.length === 0) {
      setRows([...defaultRows]);
    } else {
      const filteredRows = rows.filter((row) => {
        return (
          row.text.toLowerCase().includes(searchedVal.toLowerCase()) ||
          row.targetName.toLowerCase().includes(searchedVal.toLowerCase())
        );
      });
      setRows(filteredRows);
    }
  };

  return (
    <>
      <Helmet>
        <title> Bingo Game Questions </title>
      </Helmet>

      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            Game Questions
          </Typography>
          {rows !== null && rows.length === 0 && !loading && (
            <Button
              variant="contained"
              startIcon={<Iconify icon="eva:flip-2-outline" />}
              onClick={() => handleGenerateQuestions()}
              disabled={loading}
            >
              Generate Questions
            </Button>
          )}
          <Button
            variant="contained"
            startIcon={<Iconify icon="eva:plus-outline" />}
            onClick={() =>
              navigate(`/dashboard/game/questions/create?match_id=${match}`)
            }
            disabled={loading}
          >
            Create Questions
          </Button>
        </Stack>

        <Card>
          {rows === null || loading ? (
            <Box
              sx={{ display: "flex", justifyContent: "center" }}
              style={{ padding: 20 }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <Scrollbar>
              <Box
                sx={{ display: "flex", justifyContent: "center" }}
                style={{ padding: 20 }}
              >
                <TextField
                  margin="dense"
                  id="kickoff"
                  label="Search"
                  type="email"
                  fullWidth
                  variant="standard"
                  onInput={(e) => {
                    requestSearch(e.target.value);
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Iconify icon={"eva:search-outline"} />
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>

              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>#</TableCell>
                      <TableCell>Text</TableCell>
                      <TableCell>Level</TableCell>
                      <TableCell>Logo</TableCell>
                      <TableCell>Correct</TableCell>
                      <TableCell align="right"></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows.map((row, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell component="th" scope="row">
                          {index + 1}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.targetName} {row.text}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.level}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          <Avatar
                            alt="Logo"
                            src={
                              row.type === "team"
                                ? `https://allstarvotefilesde.blob.core.windows.net/nhl-team-logos/${row.logoId}.svg`
                                : `https://cms.nhl.bamgrid.com/images/headshots/current/168x168/${row.logoId}.jpg`
                            }
                          />
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.isCorrect ? (
                            <Iconify
                              icon={"eva:checkmark-circle-2-outline"}
                              sx={{ color: "green" }}
                            />
                          ) : (
                            <Iconify
                              icon={"eva:close-circle-outline"}
                              sx={{ color: "red" }}
                            />
                          )}
                        </TableCell>
                        <TableCell align="right">
                          <IconButton
                            size="large"
                            color="inherit"
                            onClick={handleOpenMenu}
                            id={row.questionId}
                          >
                            <Iconify icon={"eva:more-vertical-fill"} />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Scrollbar>
          )}
        </Card>
      </Container>

      <Dialog
        open={openConfirm}
        onClose={() => setOpenConfirm(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Are you sure you want to delete question?
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            All cards with this question would effected.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenConfirm(false)}>Cancel</Button>
          <Button onClick={() => deleteGameHandler(true)} autoFocus>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: "top", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: {
            p: 1,
            width: 140,
            "& .MuiMenuItem-root": {
              px: 1,
              typography: "body2",
              borderRadius: 0.75,
            },
          },
        }}
      >
        <MenuItem
          sx={{ color: "error.main" }}
          onClick={() => setOpenConfirm(true)}
        >
          <Iconify icon={"eva:trash-2-outline"} sx={{ mr: 2 }} />
          Delete
        </MenuItem>
      </Popover>
    </>
  );
}
